// Stepper — 3-step pill (Pick & write / Record / Send).
//
// Five internal stages collapse onto three customer-visible steps so the
// progress feels reasonable instead of endless. Welcome and Thanks
// intentionally render no stepper (they're framing, not work).
//
// Stage map:
//   pick, fill          → step 1 of 3 — Pick & write
//   record, between     → step 2 of 3 — Record
//   submit              → step 3 of 3 — Send
//
// Anything else (welcome, thanks) returns null.

const STEPS = [
  { id: 'script', label: 'Pick & write', stages: ['pick', 'fill'] },
  { id: 'record', label: 'Record',       stages: ['record', 'between'] },
  { id: 'submit', label: 'Send',         stages: ['submit'] },
];

export default function Stepper({ stage }) {
  const idx = STEPS.findIndex((s) => s.stages.includes(stage));
  if (idx < 0) return null;
  return (
    <div className="vt-stepper-wrap animate-fade-in-up">
      <span className="vt-s-label">Step {idx + 1} of {STEPS.length}</span>
      <div className="vt-stepper">
        {STEPS.map((s, i) => (
          <span key={s.id} className="flex items-center gap-2">
            {i > 0 && <span className={'vt-s-bar' + (i <= idx ? ' done' : '')}></span>}
            <span
              className={
                'vt-s-dot' +
                (i < idx ? ' done' : '') +
                (i === idx ? ' active' : '')
              }
              title={s.label}
            ></span>
          </span>
        ))}
      </div>
      <span className="vt-s-label" style={{ color: '#080808' }}>
        {STEPS[idx].label}
      </span>
    </div>
  );
}
